import { DisableDomainFnReq, DisableDomainFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class DisableDomainInteractor {
  private readonly disableDomainFn = httpsCallable<DisableDomainFnReq, DisableDomainFnRes>(
    this.functions,
    'disableDomain',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<void> {
    await this.disableDomainFn();
  }
}
